import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  destroyOrphanProxmox,
  getReconciliationReport,
  importOrphanProxmox,
  softDeleteOrphanDB,
  syncDrift,
} from "@/api/endpoints/reconciliation";

const RECONCILE_KEY = ["admin", "reconciliation"] as const;

export function useReconciliationReport() {
  return useQuery({
    queryKey: RECONCILE_KEY,
    queryFn: getReconciliationReport,
    staleTime: 60_000,
  });
}

export function useSoftDeleteOrphanDB() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: softDeleteOrphanDB,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: RECONCILE_KEY });
      qc.invalidateQueries({ queryKey: ["vms"] });
    },
  });
}

export function useImportOrphanProxmox() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      node,
      vmid,
      tenantId,
      serviceTier,
    }: {
      node: string;
      vmid: number;
      tenantId: number;
      serviceTier?: "A" | "B" | "C";
    }) =>
      importOrphanProxmox(node, vmid, {
        tenant_id: tenantId,
        service_tier: serviceTier ?? "A",
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: RECONCILE_KEY });
      qc.invalidateQueries({ queryKey: ["vms"] });
    },
  });
}

export function useDestroyOrphanProxmox() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ node, vmid }: { node: string; vmid: number }) =>
      destroyOrphanProxmox(node, vmid),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: RECONCILE_KEY });
    },
  });
}

export function useSyncDrift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: syncDrift,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: RECONCILE_KEY });
      qc.invalidateQueries({ queryKey: ["vms"] });
    },
  });
}
